import { createTheme } from "@aws-amplify/ui-react";

/**
 * Amplify Authenticator theme that maps Indigo design system tokens
 * to Amplify's native theme tokens, eliminating the need for CSS !important overrides.
 */
export const authTheme = createTheme({
  name: "indigo-auth",
  tokens: {
    fonts: {
      default: {
        variable: { value: "var(--indigo-font-body)" },
        static: { value: "var(--indigo-font-body)" },
      },
    },
    colors: {
      font: {
        primary: { value: "var(--indigo-text-primary)" },
        secondary: { value: "var(--indigo-text-secondary)" },
        interactive: { value: "var(--indigo-sky-500)" },
        hover: { value: "var(--indigo-sky-600)" },
        focus: { value: "var(--indigo-sky-600)" },
        inverse: { value: "var(--indigo-text-inverse)" },
      },
      border: {
        focus: { value: "var(--indigo-textfield-border-focus-color)" },
      },
    },
    radii: {
      small: { value: "var(--indigo-textfield-border-radius)" },
      medium: { value: "var(--indigo-radius-md)" },
    },
    components: {
      authenticator: {
        container: {
          widthMax: { value: "100%" },
        },
        router: {
          borderWidth: { value: "0" },
          boxShadow: { value: "none" },
          backgroundColor: { value: "transparent" },
        },
        form: {
          padding: { value: "0" },
        },
      },
      fieldcontrol: {
        borderColor: { value: "transparent" },
        borderRadius: { value: "var(--indigo-textfield-border-radius)" },
        color: { value: "var(--indigo-textfield-text-color)" },
        fontSize: { value: "var(--indigo-textfield-font-size)" },
        lineHeight: { value: "var(--indigo-textfield-line-height)" },
        paddingBlockStart: { value: "var(--indigo-textfield-padding)" },
        paddingBlockEnd: { value: "var(--indigo-textfield-padding)" },
        paddingInlineStart: { value: "var(--indigo-textfield-padding)" },
        paddingInlineEnd: { value: "var(--indigo-textfield-padding)" },
        _focus: {
          borderColor: { value: "var(--indigo-textfield-border-focus-color)" },
          boxShadow: { value: "none" },
        },
      },
      field: {
        fontSize: { value: "14px" },
        label: {
          color: { value: "var(--indigo-text-tertiary)" },
        },
      },
      button: {
        fontSize: { value: "var(--indigo-font-size-md)" },
        fontWeight: { value: "700" },
        borderRadius: { value: "var(--indigo-radius-md)" },
        backgroundColor: { value: "transparent" },
        borderColor: { value: "transparent" },
        color: { value: "var(--indigo-text-secondary)" },
        _hover: {
          backgroundColor: { value: "var(--indigo-gray-50)" },
          borderColor: { value: "transparent" },
          color: { value: "var(--indigo-text-secondary)" },
        },
        _active: {
          backgroundColor: { value: "var(--indigo-gray-100)" },
          borderColor: { value: "transparent" },
          color: { value: "var(--indigo-text-secondary)" },
        },
        _focus: {
          backgroundColor: { value: "transparent" },
          borderColor: { value: "transparent" },
          boxShadow: { value: "none" },
        },
        primary: {
          backgroundColor: { value: "var(--indigo-sky-300)" },
          color: { value: "var(--indigo-text-on-accent)" },
          borderColor: { value: "transparent" },
          _hover: {
            backgroundColor: { value: "var(--indigo-sky-400)" },
            color: { value: "var(--indigo-text-on-accent)" },
            borderColor: { value: "transparent" },
          },
          _focus: {
            backgroundColor: { value: "var(--indigo-sky-400)" },
            color: { value: "var(--indigo-text-on-accent)" },
            borderColor: { value: "transparent" },
            boxShadow: { value: "none" },
          },
          _active: {
            backgroundColor: { value: "var(--indigo-sky-400)" },
            color: { value: "var(--indigo-text-on-accent)" },
            borderColor: { value: "transparent" },
          },
          _disabled: {
            backgroundColor: { value: "var(--indigo-sky-300)" },
            color: { value: "var(--indigo-text-on-accent)" },
            borderColor: { value: "transparent" },
          },
          _loading: {
            backgroundColor: { value: "var(--indigo-sky-300)" },
            color: { value: "var(--indigo-text-on-accent)" },
            borderColor: { value: "transparent" },
          },
        },
        link: {
          backgroundColor: { value: "transparent" },
          borderColor: { value: "transparent" },
          color: { value: "var(--indigo-sky-500)" },
          _hover: {
            backgroundColor: { value: "transparent" },
            borderColor: { value: "transparent" },
            color: { value: "var(--indigo-sky-600)" },
          },
          _focus: {
            backgroundColor: { value: "transparent" },
            borderColor: { value: "transparent" },
            color: { value: "var(--indigo-sky-600)" },
            boxShadow: { value: "none" },
          },
          _active: {
            backgroundColor: { value: "transparent" },
            borderColor: { value: "transparent" },
            color: { value: "var(--indigo-sky-600)" },
          },
        },
      },
    },
  },
});
